import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { Button } from '@material-ui/core/index.js';
import { withLocalization } from 'contexts/LocalizationContext.jsx';

import { withFirebase } from 'components/Firebase/index.js';
import config from '../../client-config.js';
import { Loader } from '@bambuser-ui';

const needsEmailVerification = authUser => {
  if (config.useCustomAuth) {
    return authUser && !authUser.emailVerified;
  }
  return authUser && !authUser.emailVerified && authUser.providerData.map(provider => provider.providerId).includes('password');
};

const withEmailVerification = Component => {
  class WithEmailVerification extends React.Component {
    constructor(props) {
      super(props);

      const needsTokenRefresh = (localStorage.getItem('emailVerificationNeedsRefreshedToken') === 'true');
      this.state = { isSent: false, needsTokenRefresh };
    }

    componentDidMount() {
      if (this.state.needsTokenRefresh) {
        this.onRefreshToken();
      }
    }

    onRefreshToken = async () => {
      // Request a new token that includes correct user verified status to make sure backend will also know the user is verified...
      console.log('Refreshing firebase token...');
      await this.props.firebase.auth.currentUser.getIdToken(true);

      // Clear flag and announce the child component may now be shown
      localStorage.removeItem('emailVerificationNeedsRefreshedToken');
      this.setState({ needsTokenRefresh: false });
    };

    onSendEmailVerification = () => {
      this.props.firebase.doSendEmailVerification().then(() => {
        this.setState({ isSent: true });
        localStorage.setItem('emailVerificationNeedsRefreshedToken', 'true');
      });
    };

    render() {
      const { localization } = this.props;
      const { labels } = localization;

      if (this.state.needsTokenRefresh) {
        return <Loader />;
      }

      return needsEmailVerification(this.props.authUser) ? (
        <div style={{ margin: '2em' }}>
          {this.state.isSent ? (
            <div>
              <h1>{labels.emailConfirmationSentTitle}</h1>
              <p>{labels.emailConfirmationSentDescription}</p>
            </div>
          ) : (
            <div>
              <h1>{labels.verifyEmailTitle}</h1>
              <p>{labels.verifyEmailDescription}</p>
            </div>
          )}
          <br />
          <br />
          <Button color="primary" onClick={this.onSendEmailVerification} disabled={this.state.isSent}>
            {labels.sendConfirmationEmailButtonText}
          </Button>
        </div>
      ) : (
        <Component {...this.props} />
      );
    }
  }

  const mapStateToProps = state => ({
    authUser: state.sessionState.authUser,
  });

  return compose(withFirebase, withLocalization(getLabels), connect(mapStateToProps))(WithEmailVerification);
};

const getLabels = (getText) => ({
  emailConfirmationSentTitle: getText('withEmailVerificationHOC.emailConfirmationSentTitle'),
  emailConfirmationSentDescription: getText('withEmailVerificationHOC.emailConfirmationSentDescription'),
  verifyEmailTitle: getText('withEmailVerificationHOC.verifyEmailTitle'),
  verifyEmailDescription: getText('withEmailVerificationHOC.verifyEmailDescription'),
  sendConfirmationEmailButtonText: getText('withEmailVerificationHOC.sendConfirmationEmailButtonText'),
});

export default withEmailVerification;
